import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CoolLib4444Service {

  constructor() { }
}
